module.exports = __webpack_public_path__ + "01_long_black.44e0a9ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer5/01_long_black.png
// module id = ICO0
// module chunks = 0